import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';
import classNames from 'classnames';

import Box from '../box/box.jsx';
import { STAGE_DISPLAY_SIZES } from '../../lib/layout-constants.js';
import StageHeader from '../../containers/stage-header.jsx';
import Stage from '../../containers/stage.jsx';
import Loader from '../loader/loader.jsx';

import styles from './stage-wrapper.css';

const StageWrapperComponent = function (props) {
    const {
        isRtl,
        isRendererSupported,
        loading,
        stageSize,
        btnFalse,
        showStage,
        vm
    } = props;

    return (
        <Box
            className={styles.stageWrapper}
            dir={isRtl ? 'rtl' : 'ltr'}
        >
            {/* <Box className={classNames(styles.stageMenuWrapper,{[styles.stageMenuWrapperHide]:!showStage})}> */}
            <Box className={classNames(styles.stageMenuWrapper)}>

                {/* <div style={{ position: 'absolute', zIndex: 1, cursor: 'pointer' }}
                    onClick={() => { vm.showVideo() }}
                >
                    开启摄像头
                </div>
                <div style={{ position: 'absolute', top: '20px', zIndex: 1, cursor: 'pointer' }}
                    onClick={() => { vm.closeVideo() }}
                >
                    关闭摄像头
                </div> */}
                <StageHeader
                    stageSize={stageSize}
                    vm={vm}
                />
            </Box>
            {/* <Box className={classNames(styles.stageCanvasWrapper,{[styles.stageCanvasWrapperHide]:!showStage})}> */}
            <Box className={classNames(styles.stageCanvasWrapper)}>
                {
                    isRendererSupported ?
                        <Stage
                            stageSize={stageSize}
                            btnFalse={btnFalse}
                            vm={vm}
                        /> :
                        null
                }
            </Box>
            {loading ? (
                <Loader />
            ) : null}
        </Box>
    );
};

StageWrapperComponent.propTypes = {
    isRendererSupported: PropTypes.bool.isRequired,
    isRtl: PropTypes.bool,
    loading: PropTypes.bool,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default StageWrapperComponent;
